import { Dispatch, FC, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'
import { useIonModal } from '@ionic/react'

import { CategoriesModal } from '@/components/organisms/CategoriesModal'

import { Category } from '@/services/categories'

type CategoriesModalButtonProps = {
  selectedCategory: Category
  setSelectedCategory: Dispatch<SetStateAction<Category>>
}

export const CategoriesModalButton: FC<CategoriesModalButtonProps> = ({
  selectedCategory,
  setSelectedCategory,
}) => {
  const { t } = useTranslation('common')
  const [openModal, closeModal] = useIonModal(CategoriesModal, {
    onDismiss: () => closeModal(),
    setSelectedCategory,
  })

  if (selectedCategory) return null

  return (
    <p
      className="font-bold cursor-pointer text-primary"
      onClick={() => openModal({ cssClass: 'full-screen-modal' })}
    >
      {t('discover.categoriesTitle')}
    </p>
  )
}
